import { jsx as _jsx } from "react/jsx-runtime";
import { Block } from "./Block";
import { Link } from "./Link";
import { Text } from "./Text";
const isNotNull = (value) => value !== null;
export const Heading = ({ data, options }) => {
    if (data.children.length === 0) {
        return null;
    }
    const children = data.children.filter(isNotNull).map((headingChild) => {
        switch (headingChild.type) {
            case "text":
                return (_jsx(Text, { data: headingChild, options: options }, headingChild.text));
            case "block":
                return (_jsx(Block, { data: headingChild, options: options }, headingChild.fields.label));
            default:
                return (_jsx(Link, { data: headingChild, options: options }, headingChild.id));
        }
    });
    if (options?.heading) {
        return options.heading(data, children);
    }
    else {
        switch (data.tag) {
            case "h1":
                return _jsx("h1", { children: children });
            case "h2":
                return _jsx("h2", { children: children });
            case "h3":
                return _jsx("h3", { children: children });
            case "h4":
                return _jsx("h4", { children: children });
            case "h5":
                return _jsx("h5", { children: children });
            case "h6":
                return _jsx("h6", { children: children });
        }
    }
};
